import _ from 'lodash';

export const arraysHasCommonElements = (
  arr1: Array<string | number>,
  arr2: Array<string | number>
): boolean => {
  return arr1.some((item) => arr2.includes(item));
};

export function arrayToObject<T>(
  arr: Array<T>,
  key?: string
): { [s: string]: T } {
  return arr.reduce((obj, item) => {
    _.set(obj, key ? _.get(item, key) : item, item);
    return obj;
  }, {});
}
